export default __webpack_public_path__ + "static/media/coffee-factory-logo-small.8b6e2707.png";